// extracted by mini-css-extract-plugin
export default {"zoomModal":"z3-z"};